import React from 'react';
import Menu from '../../components/menu/Menu';
import Footer from '../../components/Footer/Footer';
import './css/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Menu />
      <div className="policy-page">
        <div className="policy-container">
          <div className="policy-header">
            <h1>Политика в отношении обработки персональных данных</h1>
            <p className="policy-update">Последнее обновление: 18 ноября 2025 года</p>
          </div>

          <div className="policy-content">
            <section className="policy-section">
              <h2>1. Общие положения</h2>
              <p>
                1.1. Настоящая Политика в отношении обработки персональных данных (далее — «Политика») 
                разработана в соответствии с Федеральным законом от 27 июля 2006 г. № 152-ФЗ «О персональных данных» 
                и определяет порядок обработки персональных данных и меры по обеспечению безопасности 
                персональных данных в ООО "АЛЬТКОР" (далее — «Оператор»).
              </p>
              <p>
                1.2. Политика действует в отношении всей информации, которую Оператор может получить 
                о Пользователе во время использования сайта <strong>altcor.ru</strong>, его поддоменов 
                и связанных сервисов (далее — «Сайт»).
              </p>
            </section>

            <section className="policy-section">
              <h2>2. Основные понятия, используемые в Политике</h2>
              <div className="terms-list">
                <div className="term-item">
                  <strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно 
                  определенному или определяемому физическому лицу (субъекту персональных данных).
                </div>
                <div className="term-item">
                  <strong>Обработка персональных данных</strong> — любое действие (операция) или совокупность 
                  действий (операций), совершаемых с использованием средств автоматизации или без использования 
                  таких средств с персональными данными.
                </div>
                <div className="term-item">
                  <strong>Конфиденциальность персональных данных</strong> — обязательное для соблюдения 
                  Оператором требование не допускать их распространения без согласия субъекта персональных данных.
                </div>
                <div className="term-item">
                  <strong>Пользователь</strong> — лицо, использующее Сайт Оператора.
                </div>
                <div className="term-item">
                  <strong>Cookies</strong> — небольшие фрагменты данных, отправляемые веб-сервером и 
                  хранимые на устройстве Пользователя.
                </div>
                <div className="term-item">
                  <strong>IP-адрес</strong> — уникальный сетевой адрес узла в компьютерной сети.
                </div>
              </div>
            </section>

            <section className="policy-section">
              <h2>3. Основные права и обязанности Оператора</h2>
              <p><strong>3.1. Оператор имеет право:</strong></p>
              <ul className="policy-list">
                <li>Обрабатывать персональные данные Пользователей в соответствии с настоящей Политикой</li>
                <li>Получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные</li>
                <li>Требовать от субъекта персональных данных предоставления дополнительной информации</li>
                <li>Обрабатывать общедоступные персональные данные</li>
              </ul>
              
              <p><strong>3.2. Оператор обязан:</strong></p>
              <ul className="policy-list">
                <li>Обрабатывать персональные данные в порядке, установленном законодательством</li>
                <li>Предоставлять субъекту персональных данных информацию concerning обработке его персональных данных</li>
                <li>Принимать необходимые правовые, организационные и технические меры для защиты персональных данных</li>
                <li>Опубликовать или иным образом обеспечить неограниченный доступ к настоящей Политике</li>
                <li>Прекратить обработку и уничтожить персональные данные в установленных случаях</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Основные права субъекта персональных данных</h2>
              <p>Субъект персональных данных имеет право:</p>
              <ul className="policy-list">
                <li>На получение информации concerning обработке его персональных данных</li>
                <li>На уточнение, блокирование или уничтожение его персональных данных</li>
                <li>На отзыв согласия на обработку персональных данных</li>
                <li>На обжалование действий или бездействия Оператора</li>
                <li>На защиту своих прав и законных интересов, в том числе на возмещение убытков и компенсацию морального вреда</li>
                <li>На получение информации concerning условиях обработки персональных данных</li>
                <li>На получение копии любой информации, обрабатываемой Оператором</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. Принципы обработки персональных данных</h2>
              <div className="principles-grid">
                <div className="principle-card">
                  <h3>Законность и справедливость</h3>
                  <p>Обработка осуществляется на законных и справедливых основаниях</p>
                </div>
                <div className="principle-card">
                  <h3>Ограничение целей</h3>
                  <p>Данные собираются для конкретных, законных целей</p>
                </div>
                <div className="principle-card">
                  <h3>Минимизация данных</h3>
                  <p>Собираются только необходимые для целей обработки данные</p>
                </div>
                <div className="principle-card">
                  <h3>Точность</h3>
                  <p>Персональные данные должны быть точными и актуальными</p>
                </div>
                <div className="principle-card">
                  <h3>Ограничение хранения</h3>
                  <p>Данные хранятся не дольше необходимого срока</p>
                </div>
                <div className="principle-card">
                  <h3>Безопасность</h3>
                  <p>Обеспечивается надлежащая защита персональных данных</p>
                </div>
              </div>
            </section>

            <section className="policy-section">
              <h2>6. Цели обработки персональных данных</h2>
              <ul className="policy-list">
                <li>Идентификация Пользователя в рамках соглашений и договоров</li>
                <li>Предоставление доступа к персонализированным ресурсам Сайта</li>
                <li>Установление с Пользователем обратной связи, включая уведомления, запросы</li>
                <li>Предоставление эффективной клиентской и технической поддержки</li>
                <li>Проведение статистических и иных исследований на основе обезличенных данных</li>
                <li>Информирование о новых продуктах, специальных предложениях и различных событиях</li>
                <li>Заключение, исполнение и прекращение гражданско-правовых договоров</li>
                <li>Обработка запросов и заявок от Пользователя</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>7. Правовые основания обработки персональных данных</h2>
              <p>Оператор обрабатывает персональные данные Пользователя на следующих правовых основаниях:</p>
              <ul className="policy-list">
                <li>Федеральный закон от 27.07.2006 № 152-ФЗ "О персональных данных"</li>
                <li>Уставные документы Оператора</li>
                <li>Договоры, заключаемые между Оператором и субъектом персональных данных</li>
                <li>Согласие Пользователя на обработку его персональных данных</li>
                <li>Осуществление прав и законных интересов Оператора</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>8. Состав обрабатываемых персональных данных</h2>
              <p><strong>8.1. Персональные данные, предоставляемые Пользователем:</strong></p>
              <ul className="policy-list">
                <li>Фамилия, имя, отчество</li>
                <li>Адрес электронной почты</li>
                <li>Номер телефона</li>
                <li>Должность и место работы</li>
                <li>Реквизиты компании</li>
                <li>Иные данные, предоставляемые Пользователем</li>
              </ul>
              
              <p><strong>8.2. Данные, автоматически собираемые при использовании Сайта:</strong></p>
              <ul className="policy-list">
                <li>IP-адрес</li>
                <li>Данные файлов cookie</li>
                <li>Информация о браузере и устройстве</li>
                <li>Дата и время доступа</li>
                <li>Адреса запрашиваемых страниц</li>
                <li>Реферер (адрес предыдущей страницы)</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>9. Порядок сбора, хранения, передачи и других видов обработки персональных данных</h2>
              <p>
                9.1. Обработка персональных данных Пользователя осуществляется с соблюдением принципов 
                и правил, предусмотренных Федеральным законом № 152-ФЗ «О персональных данных».
              </p>
              <p>
                9.2. Обработка персональных данных допускается в следующих случаях:
              </p>
              <ul className="policy-list">
                <li>Обработка осуществляется с согласия субъекта персональных данных</li>
                <li>Обработка необходима для достижения целей, предусмотренных законом</li>
                <li>Обработка осуществляется для исполнения договора, стороной которого является субъект</li>
                <li>Обработка осуществляется для осуществления прав и законных интересов Оператора</li>
              </ul>
              <p>
                9.3. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, 
                исключающие доступ к персональным данным неуполномоченных лиц.
              </p>
            </section>

            <section className="policy-section">
              <h2>10. Использование файлов cookie и аналитических сервисов</h2>
              <p>
                10.1. На Сайте используются файлы cookie и аналогичные технологии для обеспечения корректной работы 
                Сайта, сбора аналитической информации и улучшения качества предоставляемых услуг.
              </p>
              <p><strong>10.2. Категории используемых файлов cookie:</strong></p>
              <ul className="policy-list">
                <li>
                  <strong>Необходимые</strong> — обеспечивают работу основных функций Сайта. Без этих файлов 
                  Сайт не может работать корректно.
                </li>
                <li>
                  <strong>Аналитические и маркетинговые</strong> — позволяют анализировать эффективность работы 
                  Сайта с помощью инструментов веб-аналитики, собирать обезличенную информацию об источниках 
                  трафика, посещаемости Сайта и оценивать эффективность рекламы. К таким сервисам относится 
                  Яндекс.Метрика.
                </li>
              </ul>
              <p>
                10.3. Подробнее о файлах cookie Яндекс.Метрики можно узнать по ссылке:{' '}
                <a 
                  href="https://yandex.ru/support/metrica/general/cookie-usage.html" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="policy-link"
                >
                  https://yandex.ru/support/metrica/general/cookie-usage.html
                </a>.
              </p>
              <p>
                10.4. Пользователь может отключить использование файлов cookie в настройках своего браузера. 
                Однако это может ограничить функциональность Сайта.
              </p>
            </section>

            <section className="policy-section">
              <h2>11. Трансграничная передача персональных данных</h2>
              <p>
                11.1. Оператор до начала осуществления трансграничной передачи персональных данных обязан 
                убедиться в том, что иностранным государством, на территорию которого осуществляется передача 
                персональных данных, обеспечивается надежная защита прав субъектов персональных данных.
              </p>
              <p>
                11.2. Трансграничная передача персональных данных на территории иностранных государств, 
                не отвечающих вышеуказанным требованиям, может осуществляться только в случае наличия 
                согласия в письменной форме субъекта персональных данных.
              </p>
            </section>

            <section className="policy-section">
              <h2>12. Сроки обработки персональных данных</h2>
              <p>
                12.1. Сроки обработки персональных данных определяются исходя из целей обработки, 
                но не дольше срока, предусмотренного законодательством Российской Федерации.
              </p>
              <p>
                12.2. Персональные данные, срок обработки которых истек, должны быть уничтожены, 
                если иное не предусмотрено федеральным законом.
              </p>
              <p>
                12.3. Срок обработки персональных данных может быть продлен в случае, если имеется 
                согласие субъекта персональных данных, либо если такая возможность предусмотрена 
                законодательством Российской Федерации.
              </p>
            </section>

            <section className="policy-section">
              <h2>13. Заключительные положения</h2>
              <p>
                13.1. Пользователь может получить любые разъяснения по интересующим вопросам, 
                касающимся обработки его персональных данных, обратившись к Оператору по 
                контактным данным, указанным в разделе 14 настоящей Политики.
              </p>
              <p>
                13.2. В данном документе будут отражены любые изменения политики обработки персональных 
                данных Оператором. Политика действует бессрочно до замены ее новой версией.
              </p>
              <p>
                13.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет 
                по адресу: <strong>https://altcor.ru/privacy</strong>.
              </p>
            </section>

            <section className="policy-section">
              <h2>14. Контактная информация Оператора</h2>
              <div className="contact-info-section">
                <p><strong>Общество с ограниченной ответственностью "АЛЬТКОР"</strong></p>
                <div className="details-grid">
                  <div className="detail-item">
                    <span className="detail-label">ИНН:</span>
                    <span>9718280720</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">КПП:</span>
                    <span>771801001</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">ОГРН:</span>
                    <span>1257700217246</span>
                  </div>
                </div>
                <div className="contact-info">
                  <p><strong>Email:</strong> info@altcor.ru</p>
                  <p><strong>Телефон:</strong> +7 (495) 902-03-02</p>
                  <p><strong>Адрес для корреспонденции:</strong> 107023, город Москва, Суворовская ул, д. 19 стр. 1, помещ. 17 </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;